// @flow

import React from 'react'
import DocumentTitle from 'react-document-title'
import { connect } from 'transfer/utils/p2p-connect'
import Overpanel from 'react-components/overpanel'
import OpenBanking from './openBanking'
import { toggleOpenBankingOverpanel } from 'transfer/actions/overpanels'
import content from 'pp-react-l10n'
let i18n = content('transfer/inc/openBanking')

type Props = {
  showOpenBankingOverpanel: boolean,
  handleClose: () => any,
  handleNext: () => any,
  selectedFundingOption?: Object,
}

export function OpenBankingOverpanel({
  showOpenBankingOverpanel,
  handleNext,
  handleClose,
  selectedFundingOption,
}: Props) {
  return (
    <Overpanel
      show={showOpenBankingOverpanel}
      handleClose={() => handleClose()}
      a11yTitle={i18n('openBanking.header')}
    >
      <DocumentTitle title={`Paypal: ${i18n('openBanking.header')}`}>
        <OpenBanking
          handleNext={handleNext}
          selectedFundingOption={selectedFundingOption}
        />
      </DocumentTitle>
    </Overpanel>
  )
}

export default connect(
  ({ overpanels }) => ({
    showOpenBankingOverpanel: overpanels.showOpenBankingOverpanel,
  }),
  dispatch => ({
    handleClose: () => {
      dispatch(toggleOpenBankingOverpanel({ show: false }))
    },
  })
)(OpenBankingOverpanel)
